import {action, observable, runInAction} from 'mobx';
import {statisticsState} from '../../../../../constants/enums';
import manageStore from '../../../../../stores/ManageStore';
import projectStore from '../../../../../containers/main/project/store';

class StatisticsStore {
    @observable studentsInClass = {
        value: null,
        fetching: false,
        source: manageStore.getNumStudents,
        fetchOnce: false
    };
    @observable lessonsInLibrary = {
        value: null,
        fetching: false,
        source: projectStore.getNumLessonsInLibrary,
        fetchOnce: false
    };
    @observable openedLessons = {
        value: statisticsState.Soon,
        fetching: false,
        source: 'todo',
        fetchOnce: true
    };
    @observable averageDuration = {
        value: statisticsState.Soon,
        fetching: false,
        source: 'todo',
        fetchOnce: true
    };
    @observable createdProjects = {
        value: statisticsState.Soon,
        fetching: false,
        source: 'todo',
        fetchOnce: true
    };
    @observable studentsRecordings = {
        value: statisticsState.Soon,
        fetching: false,
        source: 'todo',
        fetchOnce: true
    };

    getAllStatistics = () => {
        this.fetchStatistics(this.studentsInClass);
        this.fetchStatistics(this.lessonsInLibrary);
    };

    @action
    fetchStatistics = async (state) => {
        state.fetching = true;
        try {
            // TODO: Promise should be replaced with request() to statistics API
            if ((state.fetchOnce && !state.fetched) || !state.fetchOnce) {
                const data = await state.source();
                runInAction(() => {
                    state.value = data || statisticsState.Empty;
                    state.fetched = true;
                });
            }
        } catch (err) {
            runInAction(() => {
                state.value = statisticsState.Error;
            });
        } finally {
            runInAction(() => {
                state.fetching = false;
            });
        }
    };
}

const statisticsStore = new StatisticsStore();
export default statisticsStore;
